document.addEventListener('change', (event) => {
    const select = event.target.closest('.variant-select-sticky');
    if (!select) return;

    const stickyForm = select.closest('product-quick-add');
    if (!stickyForm) return;

    const mainForm = document.getElementById(stickyForm.getAttribute('form'));
    if (!mainForm) return;

    // Update the main product form hidden variant input
    // const mainIdInput = mainForm.querySelector('input[name="id"]');
    // if (mainIdInput) {
    // mainIdInput.value = select.value;
    // mainIdInput.dispatchEvent(new Event('change', { bubbles: true }));
    // }
    const mainRadios = document.querySelectorAll('.product-info__variant-picker input[type="radio"]');
    console.log(mainRadios);
    console.log(select.value);
    const radio = Array.from(mainRadios).find(r => {
        console.log(r.dataset.variantId)
    });
    console.log('here ', radio)
    if (radio) {
      radio.checked = true;
      radio.dispatchEvent(new Event('change', { bubbles: true }));
    }
});